import { postData, putData } from "api/api";

export const createDiscipline = async ({ authToken, data }) => {
  return await postData(`discipline/`, data, authToken);
};

export const updateDiscipline = async ({ authToken, id, data }) => {
  return await putData(`discipline/${id}/`, data, authToken);
};
